import {
    STAMP_GRID_DATA,
    STAMP_GRID_ERROR,
    STAMP_GRID_LOADING,
    STAMP_GRID_PAGE_CHANGE,
    STAMP_GRID_STATE_CHANGE,
} from "../constants";
import { allGridColumns } from "./columns";
import { generateReducer } from "../../common/helpers";

const initialState = {
    error: null,
    stamps: [],
    isLoading: false,
    currentPage: 1,
    lastRow: null,
    pageSize: 25,
    sortModel: [
        {
            colId: "logged_at",
            sort: "desc",
        },
    ],
    filterModel: {},
    columnDefs: Object.values(allGridColumns),
};

const setGridData = (state, { stamps, lastRow }) => ({
    ...state,
    error: null,
    isLoading: false,
    lastRow,
    stamps,
});

const changeGridPage = (state, currentPage) => ({ ...state, currentPage });
const changeGridState = (state, payload) => ({ ...state, ...payload });
const setGridLoading = state => ({ ...state, isLoading: true });
const setGridError = (state, error) => ({ ...state, isLoading: false, error });

const reducers = {
    [STAMP_GRID_DATA]: setGridData,
    [STAMP_GRID_ERROR]: setGridError,
    [STAMP_GRID_LOADING]: setGridLoading,

    [STAMP_GRID_PAGE_CHANGE]: changeGridPage,
    [STAMP_GRID_STATE_CHANGE]: changeGridState,
};

export default generateReducer(reducers, initialState);
